import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import {
  StudentDormitoryApplicationAdmissionRequest,
  StudentDormitoryApplicationsReportResponse,
  StudentDormitoryDto,
} from "../../models/dtos";

export const studentDormitoriesApi = createApi({
  reducerPath: "studentDormitoriesApi",
  baseQuery: baseAuthQuery("studentDormitories"),
  tagTypes: ["StudentDormitory"],
  endpoints: (builder) => ({
    getStudentDormitoryApplicationsReport: builder.query<
      ApiResponse<StudentDormitoryApplicationsReportResponse[]>,
      void
    >({
      query: () => ({
        url: "reports/getStudentDormitoryApplications",
        method: "GET",
      }),
      providesTags: (_result, _error) => {
        return ["StudentDormitory"];
      },
    }),
    exportStudentDormitoryApplications: builder.query<{ blob: Blob; fileName: string }, void>({
      query: () => ({
        url: "reports/exportStudentDormitoryApplications",
        method: "GET",
        responseHandler: async (response) => {
          const blob = await response.blob();
          const contentDisposition = response.headers.get("Content-Disposition") || "";
          let fileName = "";

          const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]*)/i);
          if (utf8Match && utf8Match[1]) {
            fileName = decodeURIComponent(utf8Match[1]);
          } else {
            const match = contentDisposition.match(/filename="([^"]*)"/i);
            if (match && match[1]) {
              fileName = match[1];
            }
          }

          return { blob, fileName };
        },
      }),
    }),
    updateStudentBuildingRoom: builder.mutation<
      ApiResponse<boolean>,
      { studentId: number; request: Partial<StudentDormitoryDto> }
    >({
      query: ({ studentId, request }) => {
        return {
          url: `${studentId}/updateBuildingRoom`,
          method: "POST",
          body: request,
        };
      },
      invalidatesTags: (_result, _error, { studentId }) => {
        return [{ type: "StudentDormitory", id: studentId }];
      },
    }),

    createOrUpdateApplication: builder.mutation<
      ApiResponse<boolean>,
      { studentId: number; request: Partial<StudentDormitoryApplicationAdmissionRequest> }
    >({
      query: ({ studentId, request }) => {
        return {
          url: `adminapp/${studentId}`,
          method: "POST",
          body: request,
        };
      },
      invalidatesTags: (_result, _error, { studentId }) => {
        return [{ type: "StudentDormitory", id: studentId }];
      },
    }),
  }),
});

export const {
  useGetStudentDormitoryApplicationsReportQuery,
  useLazyExportStudentDormitoryApplicationsQuery,
  useUpdateStudentBuildingRoomMutation,
  useCreateOrUpdateApplicationMutation,
} = studentDormitoriesApi;
